module.exports = __webpack_public_path__ + "img/PEYTO_II.89b1db88.png";